import { createType } from "../../utils/createType";

export const BrowsableDateRangeTypes = createType('day', 'week', 'month', 'quarter', 'year');
export type BrowsableDateRangeType = typeof BrowsableDateRangeTypes[number];